var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBackupCodesmin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 41,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 33,
    fill: "#7542E5",
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 23,
    x: 4,
    y: 5,
    fill: "#fff",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 6,
    x: 2,
    y: 35,
    fill: "#054096",
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#054096",
    d: "M15.994 11.228a.69.69 0 0 0-1.023 0l-4.802 5.154a.65.65 0 0 0 0 .874l4.802 5.154a.69.69 0 0 0 1.023 0 .815.815 0 0 0 0-1.098l-4.184-4.496L16 12.32a.814.814 0 0 0-.006-1.092m7.219 0a.69.69 0 0 1 1.023 0l4.802 5.154a.65.65 0 0 1 0 .874l-4.802 5.154a.69.69 0 0 1-1.023 0 .816.816 0 0 1 0-1.098l4.184-4.496-4.19-4.496a.814.814 0 0 1 .006-1.092"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBackupCodesmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_backup_codes.min.574826092a0ae44e5167b7d0e3dbd9c4.svg";